(() => {
  const STAR = '<svg viewBox="0 0 24 24"><path d="M12 2l3 6.6 7.2.8-5.4 4.9 1.5 7.1L12 17.8 5.7 21.4l1.5-7.1L1.8 9.4 9 8.6z"/></svg>';
  document.querySelectorAll('[data-stars]').forEach((el) => {
    el.innerHTML = STAR.repeat(Number(el.dataset.stars) || 5);
  });

  // Free-shipping countdown.
  // "visitor" mode: starts on the visitor's first page view and is remembered, so reloading never restarts it.
  // While it runs, checkout applies the free-shipping code; after it ends, standard shipping applies.
  const timer = document.getElementById('timer');
  window.drFreeShip = { active: false, code: '' };
  if (timer) {
    let end;
    if (timer.dataset.mode === 'visitor') {
      const KEY = 'dr_fs_start';
      let start = 0;
      try { start = parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) {}
      if (!start) { start = Date.now(); try { localStorage.setItem(KEY, String(start)); } catch (e) {} }
      end = start + (parseFloat(timer.dataset.minutes) || 10) * 60000;
    } else {
      end = new Date(timer.dataset.end).getTime();
    }
    const pad = (n) => String(n).padStart(2, '0');
    const set = (id, v) => { document.getElementById(id).textContent = v; };
    const tick = () => {
      const left = end - Date.now();
      if (!(left > 0)) {
        window.drFreeShip = { active: false, code: '' };
        timer.style.display = 'none';
        const text = document.querySelector('#barText > span.bar-long') || document.querySelector('#barText > span:last-child');
        document.querySelectorAll('#barText .bar-long, #barText .bar-short').forEach((t) => { t.textContent = timer.dataset.expiredText; });
        if (text && !text.classList.contains('bar-long')) text.textContent = timer.dataset.expiredText;
        document.dispatchEvent(new CustomEvent('dr:freeship'));
        return;
      }
      window.drFreeShip = { active: true, code: timer.dataset.code || '' };
      const days = Math.floor(left / 8.64e7);
      document.getElementById('dBox').style.display = days ? '' : 'none';
      document.getElementById('dSep').style.display = days ? '' : 'none';
      set('tD', days);
      set('tH', pad(Math.floor(left / 3.6e6) % 24));
      set('tM', pad(Math.floor(left / 6e4) % 60));
      set('tS', pad(Math.floor(left / 1e3) % 60));
      setTimeout(tick, 1000);
    };
    tick();
  }

  // Gallery
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    const thumbs = g.querySelectorAll('.thumb');
    const slides = g.querySelectorAll('.slide');
    thumbs.forEach((t) => t.addEventListener('click', () => {
      thumbs.forEach((x) => x.classList.remove('on'));
      slides.forEach((x) => x.classList.remove('on'));
      t.classList.add('on');
      slides[t.dataset.s]?.classList.add('on');
    }));
  });

  // One-time / subscribe toggle: subscription is sent only when its input is enabled.
  document.querySelectorAll('[data-plans]').forEach((wrap) => {
    const buttons = wrap.querySelectorAll('.toggle button');
    buttons.forEach((b) => b.addEventListener('click', () => {
      buttons.forEach((x) => x.classList.toggle('on', x === b));
      const sub = b.dataset.mode === 'sub';
      wrap.classList.toggle('mode-sub', sub);
      wrap.querySelector('.toggle')?.classList.toggle('is-sub', sub);
      wrap.querySelectorAll('[data-sub-input]').forEach((i) => { i.disabled = !sub; });
    }));
    // "Switch to subscribe" link inside the gifts panel of a one-time card.
    wrap.querySelectorAll('[data-switch-sub]').forEach((b) => b.addEventListener('click', () => {
      wrap.querySelector('.toggle button[data-mode="sub"]')?.click();
    }));
    wrap.querySelectorAll('[data-plan-form]').forEach((f) => f.addEventListener('submit', () => {
      f.querySelector('button')?.setAttribute('aria-busy', 'true');
    }));
  });

  // Review tag filter
  document.querySelectorAll('[data-reviews]').forEach((wrap) => {
    const tags = wrap.querySelectorAll('.tag');
    const cards = wrap.querySelectorAll('.card');
    tags.forEach((b) => b.addEventListener('click', () => {
      const was = b.classList.contains('on');
      tags.forEach((x) => x.classList.remove('on'));
      if (!was) b.classList.add('on');
      const label = b.textContent.trim();
      cards.forEach((c) => { c.hidden = !was && !c.dataset.tags.split('|').includes(label); });
    }));
  });

  // Research popup
  document.querySelectorAll('[data-open-research]').forEach((b) => b.addEventListener('click', (e) => {
    const dlg = document.querySelector('dialog.research');
    if (!dlg) return; // footer link falls back to the product page
    e.preventDefault();
    dlg.showModal();
  }));
  if (new URLSearchParams(location.search).has('research')) document.querySelector('dialog.research')?.showModal();
  document.querySelectorAll('dialog.research').forEach((d) => {
    d.querySelector('[data-close-research]')?.addEventListener('click', () => d.close());
    d.addEventListener('click', (e) => { if (e.target === d) d.close(); });
  });

  // Mobile sticky CTA: show after the hero button scrolls away, hide while plans are on screen
  const sticky = document.querySelector('[data-m-sticky]');
  const heroBtn = document.getElementById('heroBtn');
  const plans = document.getElementById('plans');
  if (sticky && heroBtn && plans) {
    let pastHero = false;
    let plansVisible = false;
    const update = () => sticky.classList.toggle('show', pastHero && !plansVisible);
    new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting && e.boundingClientRect.top < 0; update(); }).observe(heroBtn);
    new IntersectionObserver(([e]) => { plansVisible = e.isIntersecting; update(); }, { threshold: 0.15 }).observe(plans);
  }

  // Expose the sticky header height so in-page sticky bars sit right under it.
  const topBar = document.querySelector('.top');
  if (topBar) {
    const setTopH = () => document.documentElement.style.setProperty('--dr-top-h', `${topBar.offsetHeight}px`);
    setTopH();
    new ResizeObserver(setTopH).observe(topBar);
  }

  // Pre-sell sticky button: hidden while the hero button is on screen
  const bwSticky = document.querySelector('.bw-sticky');
  const bwHeroCta = document.querySelector('.bw-hero .bw-cta');
  if (bwSticky && bwHeroCta) {
    new IntersectionObserver(([e]) => { bwSticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(bwHeroCta);
  }

  // Pre-sell review rail arrows
  document.querySelectorAll('[data-bw-rail]').forEach((rail) => {
    const sec = rail.closest('section');
    const step = () => Math.max(rail.clientWidth * 0.8, 260);
    sec?.querySelector('[data-bw-prev]')?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    sec?.querySelector('[data-bw-next]')?.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    const dots = sec?.querySelector('[data-bw-dots]');
    if (dots) {
      const pages = () => Math.max(1, Math.ceil(rail.scrollWidth / rail.clientWidth));
      const draw = () => {
        const n = pages();
        if (dots.childElementCount !== n) dots.innerHTML = '<i></i>'.repeat(n);
        const max = rail.scrollWidth - rail.clientWidth;
        const cur = max > 0 ? Math.round((rail.scrollLeft / max) * (n - 1)) : 0;
        [...dots.children].forEach((d, i) => d.classList.toggle('on', i === cur));
      };
      rail.addEventListener('scroll', draw, { passive: true });
      new ResizeObserver(draw).observe(rail);
      draw();
    }
  });

  // Research badge close (shows again on every page load)
  const trust = document.querySelector('[data-trust]');
  if (trust) {
    trust.querySelector('[data-trust-close]')?.addEventListener('click', () => {
      trust.hidden = true;
    });
  }

  // ===== Cart drawer (ColonBroom style) =====
  const cd = document.getElementById('dr-cart');
  if (cd) {
    const readJSON = (id, fb) => { try { return JSON.parse(document.getElementById(id).textContent); } catch (e) { return fb; } };
    const planData = readJSON('dr-plan-data', {});
    const giftData = readJSON('dr-gift-data', []);
    // Real $0 gift products: kept in the cart only while it holds a subscription, so they show in checkout and on the order.
    const giftLines = readJSON('dr-gift-lines', []).filter((g) => g && g.id);
    const giftIds = new Set(giftLines.map((g) => Number(g.id)));
    const isGift = (it) => giftIds.has(Number(it.variant_id));
    let syncing = false;
    const syncGifts = async (cart) => {
      if (syncing || !giftLines.length) return false;
      const main = cart.items.filter((it) => !isGift(it));
      const hasSub = main.some((it) => it.selling_plan_allocation);
      const updates = {};
      cart.items.filter(isGift).forEach((it) => { if (!hasSub || it.quantity !== 1) updates[it.key] = hasSub ? 1 : 0; });
      const missing = hasSub ? giftLines.filter((g) => !cart.items.some((it) => Number(it.variant_id) === Number(g.id))) : [];
      if (!missing.length && !Object.keys(updates).length) return false;
      syncing = true;
      try {
        if (Object.keys(updates).length) await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
        if (missing.length) {
          await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: missing.map((g) => ({ id: Number(g.id), quantity: 1, properties: { _gift: 'subscription' } })).reverse() }) });
          // Re-add the product lines so Daily Fiber stays on top of the checkout order summary (newest line shows first).
          const keep = main.map((it) => ({ id: it.variant_id, quantity: it.quantity, ...(it.selling_plan_allocation ? { selling_plan: it.selling_plan_allocation.selling_plan.id } : {}), ...(it.properties && Object.keys(it.properties).length ? { properties: it.properties } : {}) }));
          const zero = {};
          main.forEach((it) => { zero[it.key] = 0; });
          await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: zero }) });
          await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: keep.reverse() }) });
        }
      } catch (e) { /* keep the cart usable even if gift sync fails */ }
      syncing = false;
      return true;
    };
    const overlay = document.querySelector('.cd-overlay');
    const body = cd.querySelector('[data-cd-body]');
    let currency = 'USD';
    const money = (c) => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(c / 100);
    const esc = (t) => String(t ?? '').replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));
    const banner = document.querySelector('.announce');
    if (banner) cd.querySelector('[data-cd-banner]').innerHTML = banner.innerHTML;

    const open = () => { cd.classList.add('open'); cd.setAttribute('aria-hidden', 'false'); overlay.hidden = false; document.documentElement.classList.add('cd-lock'); };
    const close = () => { cd.classList.remove('open'); cd.setAttribute('aria-hidden', 'true'); overlay.hidden = true; document.documentElement.classList.remove('cd-lock'); };
    document.querySelectorAll('[data-cd-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

    const render = async (cart) => {
      if (await syncGifts(cart)) { const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } }); cart = await r.json(); }
      currency = cart.currency || currency;
      const mainItems = cart.items.filter((it) => !isGift(it));
      const count = mainItems.reduce((n, it) => n + it.quantity, 0);
      cd.querySelector('[data-cd-count]').textContent = `(${count})`;
      document.querySelectorAll('[data-cd-open] .txt').forEach((t) => { t.textContent = `Cart (${count})`; });
      if (!mainItems.length) {
        body.innerHTML = '<p class="cd-empty">Your cart is empty.</p>';
        cd.querySelector('[data-cd-total]').textContent = money(0);
        cd.querySelector('[data-cd-save]').hidden = true;
        return;
      }
      let compareTotal = 0;
      const items = mainItems.map((it) => {
        const pd = planData[it.variant_id] || {};
        const compare = (pd.compare || it.original_price) * it.quantity;
        compareTotal += Math.max(compare, it.final_line_price);
        const plan = it.selling_plan_allocation ? 'Subscription · ' + it.selling_plan_allocation.selling_plan.name.split(',')[0] : 'One-time purchase';
        return `<div class="cd-item">
          <img src="${esc(pd.img || it.image)}" alt="" width="72" height="72">
          <div class="cd-info"><b>${esc(it.product_title)}</b><span class="cd-plan">${esc(pd.title || it.variant_title)}${it.quantity > 1 ? ' × ' + it.quantity : ''}</span><span class="cd-plan2">${esc(plan)}</span>
            <span class="cd-price"><b>${money(it.final_line_price)}</b>${compare > it.final_line_price ? `<s>${money(compare)}</s>` : ''}</span></div>
          <button type="button" class="cd-rm" data-key="${esc(it.key)}" aria-label="Remove"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg></button>
        </div>`;
      }).join('');
      const hasSub = mainItems.some((it) => it.selling_plan_allocation);
      const gifts = (hasSub ? (giftLines.length ? giftLines : giftData) : []).map((g) => `<div class="cd-item cd-gift">${g.img ? `<img src="${esc(g.img)}" alt="" width="72" height="72">` : '<span></span>'}<div class="cd-info"><b>${esc(g.title)}</b><span class="cd-plan">Free with your subscription</span><span class="cd-price"><b class="cd-free">FREE</b></span></div></div>`).join('');
      const freeShip = window.drFreeShip && window.drFreeShip.active;
      const ship = `<div class="cd-item cd-ship"><span class="cd-ship-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 7h11v9H2z"/><path d="M13 10h4l3 3v3h-7"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="16.5" cy="17.5" r="1.8"/></svg></span><div class="cd-info"><b>Shipping</b><span class="cd-price">${freeShip ? '<b class="cd-free">FREE</b><s>$10.00</s>' : '<b>$10.00</b>'}</span></div></div>`;
      body.innerHTML = items + (gifts ? `<div class="cd-sep"></div>${gifts}` : '') + (ship ? `<div class="cd-sep"></div>${ship}` : '');
      body.querySelectorAll('.cd-rm').forEach((b) => b.addEventListener('click', async () => {
        b.disabled = true;
        const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.key, quantity: 0 }) });
        await render(await r.json());
      }));
      const save = compareTotal - cart.total_price;
      const saveEl = cd.querySelector('[data-cd-save]');
      saveEl.hidden = save <= 0;
      saveEl.textContent = `You save ${money(save)}`;
      // Show the amount the customer will actually pay: products + the shipping shown above.
      cd.querySelector('[data-cd-total]').textContent = money(cart.total_price + (freeShip ? 0 : 1000));
      const co = cd.querySelector('.cd-checkout');
      co.href = freeShip && window.drFreeShip.code ? `/checkout?discount=${encodeURIComponent(window.drFreeShip.code)}` : '/checkout';
    };
    document.addEventListener('dr:freeship', () => { if (cd.classList.contains('open')) refresh(); });
    const refresh = async () => { const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } }); await render(await r.json()); };

    document.querySelectorAll('[data-cd-open]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); refresh(); open(); }));
    document.querySelectorAll('[data-plan-form]').forEach((f) => f.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = f.querySelector('button');
      btn?.setAttribute('aria-busy', 'true');
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) });
        if (!r.ok) throw new Error('add failed');
        await refresh();
        open();
      } catch (err) {
        f.submit();
      } finally {
        btn?.removeAttribute('aria-busy');
      }
    }));
  }
})();
